import React from 'react';
import { cn } from '@/lib/utils';

/**
 * Alert Component
 * 
 * Componente de alerta flexible y reutilizable
 * Soporta diferentes variantes y permite contenido personalizado
 */
const Alert = React.forwardRef(({ className, variant, ...props }, ref) => {
  return (
    <div
      ref={ref}
      role="alert"
      className={cn(
        "relative w-full rounded-lg border p-4",
        variant === "destructive"
          ? "border-red-500/50 text-red-600 bg-red-50"
          : "border-gray-200 text-gray-900",
        className
      )}
      {...props}
    />
  );
});

Alert.displayName = "Alert";

/**
 * AlertTitle Component
 * 
 * Título para el componente Alert
 */
const AlertTitle = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <h5
      ref={ref}
      className={cn("mb-1 font-medium leading-none tracking-tight", className)}
      {...props}
    />
  );
});

AlertTitle.displayName = "AlertTitle";

/**
 * AlertDescription Component
 * 
 * Descripción para el componente Alert
 */
const AlertDescription = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <div
      ref={ref}
      className={cn("text-sm [&_p]:leading-relaxed", className)}
      {...props}
    />
  );
});

AlertDescription.displayName = "AlertDescription";

export { Alert, AlertTitle, AlertDescription };
